/** Publisher fields needed to evaluate publish-time contract gating. */
export interface ContractGatePublisher {
  contract_signed?: boolean | null;
}

/** Guild-origin studios enter the portal before signing; publishing still requires contract. */
export function requiresContractForPublishing(
  publisher: ContractGatePublisher | null | undefined,
): boolean {
  return publisher != null && publisher.contract_signed !== true;
}

export const CONTRACT_GATE_TITLE = 'Publisher agreement required';
export const CONTRACT_GATE_MESSAGE =
  'Sign the Kinora publisher agreement before publishing content or creating campaigns.';
export const CONTRACT_GATE_PATH = '/onboarding?step=contract';
